export default {"src":"/_next/static/media/logo-meritz.487d4704.svg","height":120,"width":269,"blurWidth":0,"blurHeight":0};